$(function() {
    $(document).on('click', '[data-office-handler]', function(e) {
        e.preventDefault();
        $office_id = $(this).data('office-handler');
        console.log($office_id);
        $('[data-office]').fadeOut();
        $("[data-office*="+ $office_id +"]").fadeIn();
    });
});